// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot close search suggestion when clicking overlay 
    document.addEventListener('click', function(e) {
      if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
        var $clickedElement = jQ(e.target);
        var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
        if (isClickSuggestion) {
          this.searchAutoComplete.$element.hide();
          this.searchAutoComplete.searchInput.onCloseAutocomplete();
          this.searchAutoComplete.isOpen = false;
        }
      }
    }.bind(this), true);
  }

  InstantSearchResultItem.prototype._highlightSuggestionResult = function(resultItem, searchTerm) {
    if (Settings.getSettingValue('search.highlightSuggestionResult') && searchTerm && searchTerm.length > 1 && resultItem) {
      function createRegex(str, caseSensitive) {
        return new RegExp(str.replace(/([\(\)\{\}\[\]\.\+\-\=\\\/])/g, '\\$&'), caseSensitive ? 'g' : 'ig');
      }
  
      // Find words that are the same with the Search term
      var termElements = searchTerm.split(' ');
      var i;
      var termElementsLength = termElements.length;
      for (i = 0; i < termElementsLength; i++) {
        // Escape the following characters: ( ) { } and .
        var reg = createRegex(termElements[i]);
        var foundWords = resultItem.match(reg);
        if (foundWords !== null && foundWords.length > 0) {
          // Remove duplicate values
          foundWords = foundWords.filter(function(item, pos) {
            return foundWords.indexOf(item) == pos && item != '';
          })
          // Highlight the above words
          var k;
          var foundWordsLength = foundWords.length;
          for (k = 0; k < foundWordsLength; k++) {
            console.log(foundWords[k])
            if (foundWords[k].length > 1) {
              var reg = createRegex(foundWords[k], true);
              console.log('resultItem: ', resultItem)
              resultItem = resultItem.replace(reg, '<b>' + foundWords[k] + '</b>').replace(/ /g, '&nbsp;');
            }
          }
        }
      }
    }
    return resultItem;
  };

    InstantSearchApi.beforeCall = function (searchTerm) {
Globals.instantSearchQueryParams.h_options = []

    const isLogged = window?.customerStatusData?.isLogged
      // console.log(isLogged)
    if (!isLogged) {
       Globals.instantSearchQueryParams.h_options.push('hide-b2b');
    }

      if (isLogged) {
       Globals.instantSearchQueryParams.h_options.push('hide-d2c');
    }
      
};
  
})();